// Product photo lightbox (product pages, loaded by sections/usp-pdp-breadcrumbs.liquid).
// Replaces Horizon's zoom dialog for gallery photos: one photo at a time in a white frame,
// arrows / arrow keys / swipe, counter, thumbnail strip, click on the photo to magnify it.
// Styles: assets/usp-pdp.css ("photo lightbox").
(function () {
  if (window.uspLightboxInit) return;
  window.uspLightboxInit = true;

  var SLIDE = '.product-media-container--zoomable.product-media-container--image';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dialog, img, stage, counter, thumbs, prevBtn, nextBtn, titleEl;
  var photos = [];
  var index = 0;
  var opener = null;
  var touchX = null;

  // Shopify CDN URLs take a width parameter; the CDN never scales above the original size
  function sized(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    url = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function collectPhotos(gallery) {
    var seen = {};
    var list = [];
    gallery.querySelectorAll(SLIDE + ' .product-media[data-media-id]').forEach(function (media) {
      if (media.closest('.dialog-zoomed-gallery')) return;
      var id = media.getAttribute('data-media-id');
      var image = media.querySelector('img');
      if (!image || seen[id]) return;
      seen[id] = true;
      var full = image.getAttribute('data_max_resolution') || image.currentSrc || image.src;
      list.push({ id: id, alt: image.alt || '', full: full });
    });
    return list;
  }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'usp-lb';
    dialog.setAttribute('aria-label', 'Product photos');
    // focus the dialog itself on open, so no focus ring shows up on the close button after a mouse click
    dialog.setAttribute('autofocus', '');
    dialog.tabIndex = -1;
    dialog.innerHTML =
      '<div class="usp-lb__bar">' +
      '<p class="usp-lb__title"></p>' +
      '<span class="usp-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="usp-lb__close" aria-label="Close">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
      '</button></div>' +
      '<div class="usp-lb__main">' +
      '<button type="button" class="usp-lb__arrow usp-lb__arrow--prev" aria-label="Previous photo">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<div class="usp-lb__stage"><img class="usp-lb__img" alt="" draggable="false"></div>' +
      '<button type="button" class="usp-lb__arrow usp-lb__arrow--next" aria-label="Next photo">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button></div>' +
      '<div class="usp-lb__thumbs" role="tablist" aria-label="Choose a photo"></div>';
    document.body.appendChild(dialog);

    img = dialog.querySelector('.usp-lb__img');
    stage = dialog.querySelector('.usp-lb__stage');
    counter = dialog.querySelector('.usp-lb__count');
    thumbs = dialog.querySelector('.usp-lb__thumbs');
    prevBtn = dialog.querySelector('.usp-lb__arrow--prev');
    nextBtn = dialog.querySelector('.usp-lb__arrow--next');
    titleEl = dialog.querySelector('.usp-lb__title');

    dialog.querySelector('.usp-lb__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
    // a click on the dark area around the photo (anything but the photo, buttons and thumbnails) closes the lightbox
    dialog.addEventListener('click', function (e) {
      if (!e.target.closest('.usp-lb__stage, button')) close();
    });

    img.addEventListener('load', function () { img.classList.add('is-loaded'); updateZoomable(); });
    stage.addEventListener('click', toggleZoom);
    stage.addEventListener('mousemove', moveZoom);
    stage.addEventListener('mouseleave', function () { if (stage.classList.contains('is-zoomed')) setOrigin(50, 50); });

    stage.addEventListener('touchstart', function (e) {
      touchX = e.touches.length === 1 ? e.touches[0].clientX : null;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (touchX === null || stage.classList.contains('is-zoomed')) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 45) show(index + (dx < 0 ? 1 : -1));
    });
  }

  function renderThumbs() {
    thumbs.innerHTML = '';
    photos.forEach(function (photo, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'usp-lb__thumb';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + photos.length);
      b.innerHTML = '<img alt="" loading="lazy" src="' + sized(photo.full, 160) + '">';
      b.addEventListener('click', function () { show(i); });
      thumbs.appendChild(b);
    });
  }

  function show(i) {
    var n = photos.length;
    index = ((i % n) + n) % n;
    var photo = photos[index];
    zoomOut();
    img.classList.remove('is-loaded');
    img.removeAttribute('src');
    img.alt = photo.alt;
    img.src = sized(photo.full, 2000);
    counter.textContent = n > 1 ? index + 1 + ' / ' + n : '';
    thumbs.querySelectorAll('.usp-lb__thumb').forEach(function (t, k) {
      t.setAttribute('aria-selected', k === index ? 'true' : 'false');
      if (k === index) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    // warm up the neighbours so arrows feel instant
    [index + 1, index - 1].forEach(function (k) {
      var p = photos[((k % n) + n) % n];
      if (p && n > 1) new Image().src = sized(p.full, 2000);
    });
  }

  // magnify only when the original has noticeably more pixels than shown
  function updateZoomable() {
    var box = stage.getBoundingClientRect();
    var shown = Math.min(box.width, box.height * (img.naturalWidth / img.naturalHeight || 1));
    stage.classList.toggle('is-zoomable', img.naturalWidth > shown * 1.25 && window.matchMedia('(hover: hover)').matches);
  }

  function setOrigin(x, y) {
    img.style.transformOrigin = x + '% ' + y + '%';
  }

  function moveZoom(e) {
    if (!stage.classList.contains('is-zoomed')) return;
    var r = stage.getBoundingClientRect();
    setOrigin(((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
  }

  function toggleZoom(e) {
    if (!stage.classList.contains('is-zoomable')) return;
    if (stage.classList.contains('is-zoomed')) return zoomOut();
    var hi = sized(photos[index].full, 3840);
    if (img.src !== hi) {
      var pre = new Image();
      pre.onload = function () { if (stage.classList.contains('is-zoomed')) img.src = hi; };
      pre.src = hi;
    }
    stage.classList.add('is-zoomed');
    moveZoom(e);
  }

  function zoomOut() {
    stage.classList.remove('is-zoomed');
    setOrigin(50, 50);
  }

  function open(gallery, slide) {
    photos = collectPhotos(gallery);
    if (!photos.length) return false;
    if (!dialog) build();
    var heading = document.querySelector('.product-details h1, main h1');
    titleEl.textContent = heading ? heading.textContent.trim() : '';
    dialog.classList.toggle('usp-lb--single', photos.length < 2);
    renderThumbs();
    var media = slide.querySelector('.product-media[data-media-id]');
    var start = 0;
    photos.forEach(function (p, i) { if (media && p.id === media.getAttribute('data-media-id')) start = i; });
    opener = slide;
    document.documentElement.classList.add('usp-lb-open');
    dialog.showModal();
    dialog.focus({ preventScroll: true });
    show(start);
    return true;
  }

  function close() {
    if (!dialog || !dialog.open) return;
    zoomOut();
    dialog.close();
    document.documentElement.classList.remove('usp-lb-open');
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  // capture phase: runs before Horizon's document-level on:click handler that opens its own zoom dialog
  window.addEventListener('click', function (e) {
    var target = e.target instanceof Element ? e.target : null;
    if (!target || target.closest('.usp-lb, .dialog-zoomed-gallery, slideshow-controls, slideshow-arrows')) return;
    var slide = target.closest(SLIDE);
    var gallery = slide && slide.closest('media-gallery');
    if (!gallery) return;
    if (open(gallery, slide)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  window.addEventListener('resize', function () { if (dialog && dialog.open) updateZoomable(); });
})();
